import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from './navigation.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  menuNavigation = '';
  topMenu$: Observable<any>;
  topMenu: any;
  url;

  constructor(
    private router: Router,
    private navigationService: NavigationService,
  ) { 
    this.menuNavigation = environment.menuNavigation;
    this.topMenu = navigationService.topMenu;
    this.url = this.router.url;
  }
  
  ngOnInit() {
  }
  
  ngOnChanges() {
    this.topMenu = this.navigationService.topMenu;
    console.log(this.topMenu);
  }

  goNavigate(link: any, lastIndex) {
    let url = link.url;

    if (link.data.title) {
      url += '?title=' + encodeURIComponent(link.data.title);
    }

    if (!lastIndex) {
      this.router.navigateByUrl(url);
    }

    return;
  }

  goMain() {
    this.router.navigate(['/main']);
  }

}
